import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const InstantBonusCounter: React.FC = () => {
  const { instantBonusCounter } = useSelector(select.notification.getCounters);

  return <span>{instantBonusCounter}</span>;
};

export default InstantBonusCounter;
